export enum PessoaCrt {
    SimplesNacional = 1,
    SimplesNacionalExcessoReceita = 2,
    RegimeNormal = 3,
    Mei = 4,
    Outros = 5,
}

export enum PessoaSexo {
    NaoEspecificado = '',
    Masculino = 'M',
    Feminino = 'F',
    Outro = 'O',
}
